// extracted by mini-css-extract-plugin
export default {"formWrapper":"form_formWrapper__6-DnQ","formFull":"form_formFull__ywETM"};